import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * Changes date range to the one including the current day
 */
export const goToToday = action('GoToToday', () =>
    addDatapointConfig({
        name: 'GoToToday',
    })
);
